import { Button } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import { useUpdatePasswordMutation } from "../../../redux/slice/api/FO/compteApi";
import { IChangePassword } from "../../../models/interfaces/IPassword";
import { ConfirmationPasswordSchema } from "../Utilisateur/PasswordSchema";
import CpntForm from "../../../components/forms/CpntForm";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import CpntFormSectionNavigation from "../../../components/forms/CpntFormSectionNavigation";
import { useNavigate } from "react-router-dom";
import PasswordInput from "../../../components/forms/PasswordInput";
import { RootState } from "../../../redux/store";
import { useSelector } from "react-redux";


const PageChangementMotDePasse: React.FC = () => {
  const [updatePassword] = useUpdatePasswordMutation();
  const compte = useSelector((state: RootState) => state.compte);
  const navigate = useNavigate();
  const formMethods = useForm<IChangePassword>({
    defaultValues: {
      OldPassword: "",
      NewPassword: "",
      ConfirmationPassword: "",
    },
    resolver: yupResolver(ConfirmationPasswordSchema),
    mode: "all",
    reValidateMode: "onBlur"
  });

  const {
    handleSubmit,
    setError,
  } = formMethods;

  const onSubmit = async (data : any) => {
    try {
      const payload = await updatePassword({
        ...data,
        Login: compte.Email
      }).unwrap();
      if (payload.ChangementValide) {
        navigate("/");
        toast.success("Mot de passe modifié")
      } else {
        setError("OldPassword", { type: "required", message: "Mot de passe incorrect !" }, { shouldFocus: true })
      }
    } catch (error) {
      toast.error("Erreur lors de la modification du mot de passe")
    }
  };

  return (
    <>
    <div className="container text-center">
    <div className="row pt-3 pb-5">
          <div className="col col-6 ">
            <h2 className="titreModule titre-bleu"><i className="bi-person-circle pe-2" />Modification mot de passe</h2>
          </div>
        </div>
      <div className="row pt-3 pb-5">
      <div className="col col-md-6 offset-md-3 col-6 ">
      <FormProvider {...formMethods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <CpntForm>
              <CpntFormSection>
                <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
                  <PasswordInput
                    formName="OldPassword"
                    label="Mot de passe actuel"
                    isMandatory={true}
                  />
                  <PasswordInput
                    formName="NewPassword"
                    label="Nouveau mot de passe"
                    isMandatory={true}
                  />
                  <PasswordInput
                    formName="ConfirmationPassword"
                    label="Confirmation du nouveau mot de passe"
                    isMandatory={true}
                  />
                </CpntFormSectionContainer>
                <div></div>
                <CpntFormSectionNavigation>
              
              <Button type="submit" className="btn btn-primary">
                Enregistrer
              </Button>
            </CpntFormSectionNavigation>
              </CpntFormSection>
            </CpntForm>
            
          </form>
        </FormProvider>
        </div>
        </div>
    </div>
     
      
    </>
  );
};
export default PageChangementMotDePasse;
